import React, { useContext } from "react"
import { AppContext } from "../context/AppContext";
import sets from './../data/set.json';
import Select,{IndicatorSeparator} from 'react-select';
import Stat from "./Stat";

function TeamSlot(props) {
    const unit = props.unit;
    const slot = props.slot;
    const displayStat = props.displayStat;
    const forScreenshot = props.forScreenshot
    const onlyImage = props.onlyImage;
    const showRelics = props.showRelics
    const {searchKey,customStyle,translate,getLeaderSkillsDescription,getLeaderSkillIcon} = useContext(AppContext);
    const displayStarHero = (nb) => {
		let stars = [];
		for(let i = 0; i < nb; i++){
			stars.push(<div key={i} style={{zIndex: "1"}} className=" self-end md:mb-1"><img style={{imageRendering: '-webkit-optimize-contrast'}} className='w-[32px]' src={`/img/starBig.png`} alt="star" /></div>);
		}
		return stars;
	}
    const displayReliqueSet = (type) => {
        let mySets = [];
        let currentSet=[];
        if(type === "second") {
            currentSet = sets.filter(set => set.Icon1Path === "")
        } else {
            currentSet = sets.filter(set => set.Icon5Path === "")
        }
        for(let set of currentSet){
            mySets.push({value: set.SuitID,label: <div className="flex flex-row items-center gap-1">
                <div><img src={`img/items/${set.SuitIcon}.png`} className="w-4 h-4" alt="set"/></div>
                <div>{searchKey(set.SuitName)}</div>
                </div>});
        }
        return mySets;
    }
    const displayStatOption = (index) => {
        let myOptions = [];

        // una II => CRIT RATE ,C DMG, ATK, ATK %, DEF; DEF%,HP HP%
        let una2 = [
            {"id": "CRP","name":"AttrsView;Name;CRP","img":"EquipSuit11.png",type:"flat"},
            {"id": "CRD","name":"AttrsView;Name;CRD","img":"EquipSuit06.png",type:"flat"},
            {"id": "ATK","name":"AttrsView;Name;ATK","img":"EquipSuit01.png",type:"flat"},
            {"id": "ATK%","name":"AttrsView;Name;ATK","img":"EquipSuit01.png", type:"percent"},
            {"id": "DEF","name":"AttrsView;Name;ARM","img":"EquipSuit12.png",type:"flat"},
            {"id": "DEF%","name":"AttrsView;Name;ARM","img":"EquipSuit12.png", type:"percent"},
            {"id": "HP","name":"AttrsView;Name;HP","img":"EquipSuit10.png",type:"flat"},
            {"id": "HP%","name":"AttrsView;Name;HP","img":"EquipSuit10.png", type:"percent"},
        ]
        
        // una IV => ACC, RESIST,ATK, ATK%,DEF , DEF% , HP, HP%
        let una4 = [
            {"id": "ACC","name":"AttrsView;Name;ACC","img":"EquipSuit14.png",type:"flat"},
            {"id": "RESIST","name":"AttrsView;Name;RES","img":"EquipSuit16.png",type:"flat"},
            {"id": "ATK","name":"AttrsView;Name;ATK","img":"EquipSuit01.png",type:"flat"},
            {"id": "ATK%","name":"AttrsView;Name;ATK","img":"EquipSuit01.png", type:"percent"},
            {"id": "DEF","name":"AttrsView;Name;ARM","img":"EquipSuit12.png",type:"flat"},
            {"id": "DEF%","name":"AttrsView;Name;ARM","img":"EquipSuit12.png", type:"percent"},
            {"id": "HP","name":"AttrsView;Name;HP","img":"EquipSuit10.png",type:"flat"},
            {"id": "HP%","name":"AttrsView;Name;HP","img":"EquipSuit10.png", type:"percent"},
        ]

        // mui II => SPD,ATK,ATK%,  DEF, DEF%, HP, HP%
        let mui2 = [
            {"id": "SPD","name":"AttrsView;Name;SPEED","img":"EquipSuit04.png",type:"flat"},
            {"id": "ATK","name":"AttrsView;Name;ATK","img":"EquipSuit01.png",type:"flat"},
            {"id": "ATK%","name":"AttrsView;Name;ATK","img":"EquipSuit01.png", type:"percent"},
            {"id": "DEF","name":"AttrsView;Name;ARM","img":"EquipSuit12.png",type:"flat"},
            {"id": "DEF%","name":"AttrsView;Name;ARM","img":"EquipSuit12.png", type:"percent"},
            {"id": "HP","name":"AttrsView;Name;HP","img":"EquipSuit10.png",type:"flat"},
            {"id": "HP%","name":"AttrsView;Name;HP","img":"EquipSuit10.png", type:"percent"},
        ]
        if(index === 1) {
            una2.forEach(element => {
                myOptions.push({value: element.id,label: <div className="flex flex-row items-center gap-1">
                <div><img src={`img/items/${element.img}`} className="w-4 h-4" alt="CRP"/></div>
                <div>{searchKey(element.name)} {element.type === "percent" ? "%":""}</div>
                </div>});    
            });
        }
        if(index === 2) {
            una4.forEach(element => {
                myOptions.push({value: element.id,label: <div className="flex flex-row items-center gap-1">
                <div><img src={`img/items/${element.img}`} className="w-4 h-4" alt="CRP"/></div>
                <div>{searchKey(element.name)} {element.type === "percent" ? "%":""}</div>
                </div>});    
            });
        }
        if(index === 3) {
            mui2.forEach(element => {
                myOptions.push({value: element.id,label: <div className="flex flex-row items-center gap-1">
                <div><img src={`img/items/${element.img}`} className="w-4 h-4" alt="CRP"/></div>
                <div>{searchKey(element.name)} {element.type === "percent" ? "%":""}</div>
                </div>});    
            });
        }

        return myOptions;
    }
    
    const displayLevel = () => {
        let tabLevel = [];
        for(let i = 1;i <= 60;i++) {
            tabLevel.push({value: i, label: "Level " +i});
        }
        return tabLevel;
    }
    const updateLevel = (e) => {
        let newLevel = e.value;
        let newUnit = {...unit};
        newUnit.currentLevel = newLevel;
        props.updateUnit(newUnit);
    }
    const updateSet = (e,set) => {
        let newSet = e.value;
        let newUnit = {...unit};
        newUnit[set] = newSet;
        props.updateUnit(newUnit);
    }
    const updateStat = (e,stat) => {
        let newStat = e.target.value;
        let newUnit = {...unit};
        newUnit[stat] = newStat;
        props.updateUnit(newUnit);
    }
    const myCurrentLevel = () => {
        return {"value": unit.currentLevel,"label": "Level " + unit.currentLevel }
    }
    
    return(
        <>
            {unit != null ? 
                <div className="flex flex-col items-center teamLine relative">
                    <div onClick={() => props.removeUnit(unit)} className='flex w-full hover:cursor-pointer relative bg-[#212932]  shadow-lg rounded-lg aspect-[256/363] flex-col justify-end' style={{backgroundPosition: "-18px -40px",backgroundSize: "cover",backgroundImage: `url(/img/charArt/Tex_UI_${unit.EnglishName}_CharArt${unit.ID}.png`}}>
                        <div className='block absolute from-black right-0 h-full w-[25%] bg-gradient-to-l rounded-tr-lg'>
                            
                        </div>
                        <div className='absolute top-[-1px] right-[1px] rounded-tr-lg rounded-bl-lg w-[16%]'>
                            <img alt="type" src={`img/type/UnitJob${unit.TypeID}.png`} style={{width: '100%'}} className='rounded-tr-lg rounded-bl-lg'/>
                        </div>
                        <div className='self-end flex flex-col mt-20 gap-1'>{displayStarHero(Math.floor(unit.currentLevel / 10))}</div>
                        <div style={{zIndex: "2"}} className="flex flex-row justify-between bg-gradient-to-b from-black ">
                            <div className='w-full text-center font-bold text-sm text-white'>
                                {searchKey("Unit;NickName;"+unit.ID)} 
                                <span className="text-xs"> ({searchKey(unit.Name)})</span>    
                            </div>
                            <div className='text-white font-bold bg-black rounded self-end w-[40px]'><span className='text-violet-500 font-normal mr-1'>lvl</span>{unit.currentLevel}</div>
                        </div>
                    </div>
                    
                    {!onlyImage ?
                    <div className='level w-full mt-1'>
                        <Select classNamePrefix='filter w-full' isClearable={true} styles={customStyle}  menuPortalTarget={document.body} options={displayLevel()}
                        onChange={(evt) => updateLevel(evt)} value={myCurrentLevel()}/>
                    </div>
                    :''}
                    {showRelics ? 
                    <div className='relique mt-1 w-full'>
                        <div className='flex flex-col'>
                        
                        <div>
                        <Select placeholder={"Main Set"} classNamePrefix='filter' className='w-full mb-1' isClearable={true} styles={customStyle}  menuPortalTarget={document.body} options={displayReliqueSet("set")}
                        onChange={(evt) => updateSet(evt,"set1")} value={displayReliqueSet("set").find((e) => e.value === unit.set1)} />
                        <Select placeholder={"Secondary Set"} classNamePrefix='filter' className='w-full mb-1' isClearable={true} styles={customStyle}  menuPortalTarget={document.body} options={displayReliqueSet("second")}
                        onChange={(evt) => updateSet(evt,"set2")} value={displayReliqueSet("second").find((e) => e.value === unit.set2)} />
                        </div>
                        <div className={`flex ${forScreenshot ? 'flex-row':'flex-col 2xl:flex-row'}`}>
                        {/* stats to focus */}
                        <Select components={{IndicatorSeparator: () => null}} placeholder={"Una II"} classNamePrefix='filter' className='w-full mb-1' isClearable={false} styles={customStyle}  menuPortalTarget={document.body} options={displayStatOption(1)}
                        onChange={(evt) => updateSet(evt,"stat1")} value={displayStatOption(1).find((e) => e.value === unit.stat1)} />
                        <Select components={{IndicatorSeparator: () => null}} placeholder={"Una IV"}  classNamePrefix='filter' className='w-full mb-1' isClearable={false} styles={customStyle}  menuPortalTarget={document.body} options={displayStatOption(2)}
                        onChange={(evt) => updateSet(evt,"stat2")} value={displayStatOption(2).find((e) => e.value === unit.stat2)} /> 
                        <Select components={{IndicatorSeparator: () => null}} placeholder={"Mui II"} classNamePrefix='filter' className='w-full mb-1' isClearable={false} styles={customStyle}  menuPortalTarget={document.body} options={displayStatOption(3)}
                        onChange={(evt) => updateSet(evt,"stat3")} value={displayStatOption(3).find((e) => e.value === unit.stat3)} />
                        </div>

                        </div>
                    </div>
                    :null}
                    {slot === 0 ?
                    <div className='w-full'>
                        <div style={{boxShadow: ''}} className={`border p-1 flex flex-row items-center w-full rounded justify-between bg-[#171e26]`}>
                            <div className='max-h-[44px] '>
                                <div className={`scale-[0.40] -mt-8 -ml-8  aspect-square leaderSkill ${unit.LeaderSkill != null ? 'leaderSkillBg':''} ${getLeaderSkillIcon(unit.LeaderSkill,unit)}${unit.SkillColor}`}></div>
                            </div>
                            <div className='text-sm'>{unit.LeaderSkill != null ? getLeaderSkillsDescription(unit.LeaderSkill,unit): searchKey("CommonBattle_Info_NoLeaderSkill")}</div>    
                        </div>
                    </div>
                    :null}
                    
                    {displayStat ? <div className='stats w-full md:p-2'>
                        <Stat unit={unit} forScreenshot={forScreenshot} updateStat={updateStat}/>
                    </div>:''}
                </div>
            : <div className='relative bg-[#212932]  w-full shadow-lg rounded-lg aspect-[256/363] flex flex-col justify-center items-center' style={{backgroundPosition: "-40px",backgroundSize: "cover"}}>
                <div className="text-center text-blue-200">{translate("Select esper...")}</div>
                </div>}
        </>   
    )
}
export default TeamSlot;